<template id="challenge-card-prize">
    <div>
        <div class="prize" v-if="prizeValue" :class="{prizeMargin: !potTitleVisible}"><span>{{prizeValue}}</span></div>
        <div class="prize" v-if="potValue" :class="{prizeMargin: !potTitleVisible}">
            <div v-if="potTitleVisible">{{getPotTitle}}</div>
            <span>{{potValue}}</span>
        </div>
    </div>
</template>

<script>
export default {
  template: '#challenge-card-prize',
  props: ['prizeValue', 'potValue', 'type', 'potTitle'],
  computed: {
    potTitleVisible: function() {
      return !this.type.toLocaleLowerCase().includes('team')
    },
    getPotTitle() {
      return this.potTitle || 'Current pot'
    }
  }
}
</script>
